import { useTranslation } from "react-i18next";
import { LanguageEnum } from "@/i18n";

export default function useRTL() {
  const { i18n } = useTranslation();
  return i18n.language === LanguageEnum.AR;
}
